/* eslint-disable @typescript-eslint/class-name-casing */ /* eslint-disable
@typescript-eslint/camelcase */ /* eslint-disable
@typescript-eslint/naming-convention */

<template>
  <div class="window-container" :class="{ 'window-mobile': isDevice }">
    <v-dialog v-model="addNewRoom" max-width="490">
      <v-card>
        <form @submit.prevent="createRoom" class="mt-4">
          <v-card-title uppercase class="text-h5">
            {{ $t('Messaging.AddRoom') }}
            <v-spacer></v-spacer>
          </v-card-title>

          <v-card-text>
            <v-text-field v-model="addRoomUsername" :label="$t('Messaging.RoomName')" required></v-text-field>
          </v-card-text>

          <v-card-text>
            <v-expansion-panels accordion flat>
              <v-expansion-panel>
                <v-expansion-panel-header class="m-0 p-0 white black--text">
                  <v-card-title class="p-0">{{ $t('Messaging.Rooms') }}</v-card-title>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="px-0">
                  <v-list class="p-0">
                    <v-list-item v-for="room in allRooms" :key="room.id">
                      <v-list-item-content>
                        <v-list-item-title v-text="room.roomName"></v-list-item-title>
                      </v-list-item-content>

                      <v-list-item-action>
                        <v-btn color="primary" uppercase :disabled="isJoinRoomButtonDisabled(room)"
                               @click="joinRoom(room)">{{ $t('Messaging.Join') }}
                        </v-btn>
                      </v-list-item-action>
                    </v-list-item>
                  </v-list>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" type="submit">

              {{ $t('Messaging.CreateRoom') }}
            </v-btn>
            <v-btn color="error" @click="addNewRoom = false">
              {{ $t('GeneralTranslations.Cancel') }}
            </v-btn>
          </v-card-actions>
        </form>
      </v-card>
    </v-dialog>

    <form v-if="inviteRoomId" @submit.prevent="addRoomUser">
      <input v-model="invitedUsername" type="text" :placeholder="$t('Messaging.AddUsername')"/>
      <button type="submit" :disabled="disableForm || !invitedUsername">
        {{ $t('Messaging.AddUser') }}
      </button>
      <button class="button-cancel" @click="inviteRoomId = null">{{ $t('GeneralTranslations.Cancel') }}</button>
    </form>

    <v-row v-if="removeRoomId">
      <v-col cols="2">
        <v-select v-model="removeUserId" :items="selectedRoomDetails.users" item-value="_id" item-text="username">
        </v-select>
      </v-col>

      <v-btn v-if="removeRoomId" class="primary" :disabled="!removeUserId" @click="deleteRoomUser">

        {{ $t('Messaging.RemoveUser') }}
      </v-btn>
      <v-btn class="red" @click="removeRoomId = null"> {{ $t('GeneralTranslations.Cancel') }}</v-btn>
    </v-row>
    <v-dialog v-model="viewMembers" max-width="490">
      <v-card>
        <v-card-title uppercase class="text-h5">
          {{ $t('Messaging.RoomMembers') }}
          <v-spacer></v-spacer>
          <v-btn v-if="selectedRoomDetails" depressed color="error" @click="leaveRoom(selectedRoomDetails)">

            {{ $t('Messaging.LeaveRoom') }}
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-list class="p-0">
            <v-list-item v-for="user in selectedRoomDetails.users" :key="user._id">
              <v-list-item-avatar>
                <v-img :src="user.avatar"></v-img>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title v-text="user.username"></v-list-item-title>
              </v-list-item-content>

              <!-- <v-list-item-action
                ><v-btn class="primary" text>Remove</v-btn></v-list-item-action
              > -->
            </v-list-item>
          </v-list>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="viewRooms" max-width="490">
      <v-card>
        <v-card-title uppercase class="text-h5">
          {{ $t('Messaging.Rooms') }}
        </v-card-title>

        <v-card-text>
          <v-list class="p-0">
            <v-list-item v-for="room in allRooms" :key="room.id">
              <v-list-item-content>
                <v-list-item-title v-text="room.roomName"></v-list-item-title>
              </v-list-item-content>

              <v-list-item-action>
                <v-btn color="primary" :disabled="isJoinRoomButtonDisabled(room)" @click="joinRoom(room)">
                  {{ $t('Messaging.Join') }}
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- @add-room="addRoom" -->
    <v-row>
      <chat-window @add-room="addRoom"
                   :height="screenHeight"
                   :load-first-room="true"
                   :current-user-id="user.id"
                   :room-id="roomId"
                   :rooms="loadedRooms"
                   :loading-rooms="loadingRooms"
                   :messages="computedMessages"
                   :messages-loaded="messagesLoaded"
                   :rooms-loaded="roomsLoaded"
                   :room-actions="roomActions"
                   :menu-actions="menuActions"
                   :room-message="roomMessage"
                   :templates-text="templatesText"
                   :message-actions="messageActions"
                   @fetch-more-rooms="fetchMoreRooms"
                   @fetch-messages="fetchMessages"
                   @send-message="sendMessage"
                   @edit-message="editMessage"
                   @delete-message="deleteMessage"
                   @open-file="openFile"
                   @open-user-tag="openUserTag"
                   @room-action-handler="menuActionHandler"
                   @menu-action-handler="menuActionHandler"
                   @send-message-reaction="sendMessageReaction"
                   @typing-message="typingMessage" :username-options="{
          minUsers: 2,
          currentUser: true
        }" accepted-files="image/png, image/jpeg, image/jpg, application/pdf">
        <template #rooms-header="{  }">
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-btn class="primary m-0" block text @click="toggleViewRooms">
                  {{ $t('Messaging.Rooms') }}
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </template>

        <template #room-header="{ room }">
          <v-container>
            <v-row>
              <v-div class="ml-5 headline">
                #{{ room.roomName }}
                <span v-if="selectedRoomDetails && selectedRoomDetails.users" class="text-gray text-body-2">
                {{ $t('Messaging.RoomMembersCount', {count: selectedRoomDetails.users.length}) }}
              </span>
              </v-div>
              <v-spacer></v-spacer>

              <v-btn class="mr-5 primary" text @click="toggleViewMembers">
                {{ $t('Messaging.RoomDetails') }}
              </v-btn>
            </v-row>
          </v-container>
        </template>
      </chat-window>
    </v-row>
  </div>
</template>

<script>
import {isSameDay, parseTimestamp} from "@/utils/dates";
import ChatWindow from "vue-advanced-chat";
import "vue-advanced-chat/dist/vue-advanced-chat.css";

import * as firebase from "firebase/app";
import "firebase/firestore";
import "firebase/storage";
import "firebase/auth";
import {mapGetters, mapState} from "vuex";
import i18n from "@/plugins/vueI18n";
import {optimizePhotos} from "@/utils/upload-image";
import {fileSizeToMB, validFileSize10MB} from "@/utils/fileSizeToMB";

export default {
  components: {
    ChatWindow
  },
  emits: ["show-demo-options"],
  data() {
    return {
      roomsPerPage: 15,
      rooms: [],
      allRooms: [],
      isDevice: false,
      startRooms: null,
      endRooms: null,
      roomsLoaded: false,
      viewMembers: false,
      viewRooms: false,
      loadingRooms: true,
      allUsers: [],
      loadingLastMessageByRoom: 0,
      roomsLoadedCount: false,
      messagesPerPage: 20,
      selectedRoomDetails: {},
      messages: [],
      messagesLoaded: false,
      roomMessage: "",
      startMessages: null,
      endMessages: null,
      roomsListeners: [],
      listeners: [],
      typingMessageCache: "",
      disableForm: false,
      addNewRoom: null,
      addRoomUsername: "",
      inviteRoomId: null,
      invitedUsername: "",
      removeRoomId: null,
      removeUserId: "",
      removeUsers: [],
      showTooltip: false,
      tooltipText: '',
      tooltipPosition: { x: 0, y: 0 },
      roomActions: [
        {name: "inviteUser", title: this.$t('Messaging.InviteUser')},
        {name: "removeUser", title: this.$t('Messaging.RemoveUser')},
        {name: "deleteRoom", title: this.$t('Messaging.DeleteRoom')}
      ],
      menuActions: [
        {name: "inviteUser", title: this.$t('Messaging.InviteUser')},
        {name: "removeUser", title: this.$t('Messaging.RemoveUser')}
        //  { name: "deleteRoom", title: this.$t('Messaging.DeleteRoom') },
      ],
      messageActions: [
        {name: "replyMessage", title: this.$t('Messaging.Reply'), onlyMe: false},
        {name: "editMessage", title: this.$t('Messaging.EditMessage'), onlyMe: true},
        {name: "deleteMessage", title: this.$t('Messaging.DeleteMessage'), onlyMe: true}
      ],
      styles: {container: {borderRadius: "4px"}},
      templatesText: [
        {
          tag: "goodmorning",
          text: "Good Morning!"
        }
      ],
      dbRequestCount: 0
    };
  },

  computed: {
    facility() {
      return this.$store.state.facilityModule.selectedFacility;
    },
    loadedRooms() {
      return this.rooms.slice(0, this.roomsLoadedCount);
    },
    computedMessages() {
      return this.messages;
    },
    currentUserId() {
      return this.user?.id ?? 0;
    },
    ...mapState({
      currentFacility: state => state.authModule.currentFacility
    }),
    ...mapGetters({
      user: "user"
    }),
    screenHeight() {
      return this.isDevice
          ? window.innerHeight + "px"
          : "calc(100vh - 100px)";
    }
  },

  mounted() {
    this.fetchRooms();
    //this.updateUserOnlineStatus();
  },

  methods: {
    toggleViewMembers() {
      this.viewMembers = !this.viewMembers;
    },
    toggleViewRooms() {
      this.viewRooms = !this.viewRooms;
    },
    resetRooms() {
      this.loadingRooms = true;
      this.loadingLastMessageByRoom = 0;
      this.roomsLoadedCount = 0;
      this.rooms = [];
      this.roomsLoaded = true;
      this.startRooms = null;
      this.endRooms = null;
      this.roomsListeners.forEach(listener => listener());
      this.roomsListeners = [];
      this.resetMessages();
    },

    resetMessages() {
      this.messages = [];
      this.messagesLoaded = false;
      this.startMessages = null;
      this.endMessages = null;
      this.listeners.forEach(listener => listener());
      this.listeners = [];
    },
    async fetchRooms() {
      await this.resetRooms();
      await this.fetchUserRooms();
      await this.fetchAllRooms();
    },

    async fetchUserRooms() {
      if (this.endRooms && !this.startRooms) return (this.roomsLoaded = true);
      const currentUserId = this.$store.state.authModule.user.id;

      const roomsRef = firebase
          .firestore()
          .collection("messagingRooms")
          .where("facilityId", "==", this.currentFacility)
          .where("usersIds", "array-contains", currentUserId);
      //	.where('userIds', 'contains', this.currentUserId)
      let query = roomsRef;

      if (this.startRooms) query = query.startAfter(this.startRooms);

      const rooms = await query.get();

      // this.incrementDbCounter('Fetch Rooms', rooms.size)

      this.roomsLoaded = rooms.empty || rooms.size < this.roomsPerPage;

      if (this.startRooms) this.endRooms = this.startRooms;
      this.startRooms = rooms.docs[rooms.docs.length - 1];

      const roomList = {};
      rooms.forEach(room => {
        roomList[room.id] = {...room.data()};
      });

      const formattedRooms = [];

      Object.keys(roomList).forEach(key => {
        const room = roomList[key];

        const roomContacts = room.users.filter(
            user => user.id !== this.currentUserId
        );

        const roomAvatar =
            roomContacts.length === 1 && roomContacts[0].avatar
                ? roomContacts[0].profilePicUrl
                : "https://image.shutterstock.com/image-vector/vector-png-glowing-light-effect-260nw-1663777858.jpg";
        formattedRooms.push({
          // ...room,
          roomName: room.roomName,
          users: room.users,
          typingUsers: room.typingUsers,
          roomId: key,
          avatar: roomAvatar,
          index: room.lastUpdated.seconds,
          lastMessage: {
            content: i18n.t('Messaging.RoomCreated'),
            timestamp: this.formatTimestamp(
                new Date(room.lastUpdated.seconds),
                room.lastUpdated
            )
          }
        });
      });

      this.rooms = this.rooms.concat(formattedRooms);
      formattedRooms.map(room => this.listenLastMessage(room));

      if (!this.rooms.length) {
        this.loadingRooms = false;
        this.roomsLoadedCount = 0;
      }

      // TODO this.listenUsersOnlineStatus(formattedRooms);

      this.listenRooms(query);
    },

    async fetchAllRooms() {
      this.loadingRooms = true;
      await firebase
          .firestore()
          .collection("messagingRooms")
          .where("facilityId", "==", this.currentFacility)
          .get()
          .then(qs => {
            this.allRooms = [];

            qs.forEach(doc => {
              this.allRooms.push({
                id: doc.id,
                ...doc.data()
              });
            });
          });

      this.loadingRooms = false;
    },

    async joinRoom(room) {
      const roomId = room.id;
      const {id, profilePicUrl, name} = this.$store.state.authModule.user;

      const roomRef = firebase
          .firestore()
          .collection("messagingRooms")
          .doc(roomId);

      await roomRef.update({
        users: firebase.firestore.FieldValue.arrayUnion({
          _id: id,
          avatar: profilePicUrl,
          username: name
        }),
        usersIds: firebase.firestore.FieldValue.arrayUnion(id)
      });

      await this.fetchRooms();
    },

    async leaveRoom(room) {
      const roomId = room.roomId;
      const {id} = this.$store.state.authModule.user;

      const userToRemove = room.users.find(u => u._id === id);

      try {
        if (!roomId) {
          throw new Error("roomId is not defined");
        }

        const roomRef = firebase
            .firestore()
            .collection("messagingRooms")
            .doc(roomId);

        await roomRef.update({
          users: firebase.firestore.FieldValue.arrayRemove({
            ...userToRemove
          }),
          usersIds: firebase.firestore.FieldValue.arrayRemove(id)
        });

        await this.fetchRooms();
      } catch (e) {
        console.error(e);
      }

      this.viewMembers = false;
    },

    isJoinRoomButtonDisabled(room) {
      const findedRoom = this.rooms.find(r => r.roomId === room.id);
      return !!findedRoom;
    },

    listenLastMessage(room) {
      const roomsRef = firebase.firestore().collection("messagingRooms");
      const messagesRef = roomId =>
          roomsRef.doc(roomId).collection("messages").where("facilityId", "==", this.currentFacility)
      const listener = messagesRef(room.roomId)
          .orderBy("timestamp", "desc")
          .limit(1)
          .onSnapshot(messages => {
            // this.incrementDbCounter('Listen Last Room Message', messages.size)
            messages.forEach(message => {
              const lastMessage = this.formatLastMessage(message.data());
              const roomIndex = this.rooms.findIndex(
                  r => room.roomId === r.roomId
              );
              this.rooms[roomIndex].lastMessage = lastMessage;
              this.rooms = [...this.rooms];
            });
            if (this.loadingLastMessageByRoom < this.rooms.length) {
              this.loadingLastMessageByRoom++;

              if (this.loadingLastMessageByRoom === this.rooms.length) {
                this.loadingRooms = false;
                this.roomsLoadedCount = this.rooms.length;
              }
            }
          });

      this.roomsListeners.push(listener);
    },

    formatLastMessage(message) {
      if (!message.timestamp) return;

      let content = message.content;
      if (message.files?.length) {
        const file = message.files[0];
        content = `${file.name}.${file.extension || file.type}`;
      }

      return {
        ...message,
        ...{
          content,
          timestamp: this.formatTimestamp(
              new Date(message.timestamp.seconds * 1000),
              message.timestamp
          ),
          distributed: true,
          seen: message.senderId === this.currentUserId ? message.seen : null,
          new:
              message.senderId !== this.currentUserId &&
              (!message.seen || !message.seen[this.currentUserId])
        }
      };
    },

    formatTimestamp(date, timestamp) {
      const timestampFormat = isSameDay(date, new Date()) ? "HH:mm" : this.facility.dateFormat;
      const result = parseTimestamp(timestamp, timestampFormat);
      return timestampFormat === "HH:mm" ? `Today, ${result}` : result;
    },

    fetchMessages({room, options = {}}) {
      if (options.reset) {
        this.resetMessages();
        this.roomId = room.roomId;
      }

      if (this.endMessages && !this.startMessages) {
        return (this.messagesLoaded = true);
      }
      const roomsRef = firebase.firestore().collection("messagingRooms");
      const messagesRef = roomId =>
          roomsRef.doc(roomId).collection("messages").where("facilityId", "==", this.currentFacility);
      const ref = messagesRef(room.roomId);

      let query = ref
          .orderBy("timestamp", "desc")
          .limit(this.messagesPerPage);

      if (this.startMessages) query = query.startAfter(this.startMessages);

      this.selectedRoom = room.roomId;
      this.selectedRoomDetails = room;

      query.get().then(messages => {
        // this.incrementDbCounter('Fetch Room Messages', messages.size)
        if (this.selectedRoom !== room.roomId) return;
        if (messages.empty || messages.docs.length < this.messagesPerPage) {
          setTimeout(() => (this.messagesLoaded = true), 0);
        }
        if (this.startMessages) this.endMessages = this.startMessages;
        this.startMessages = messages.docs[messages.docs.length - 1];

        let listenerQuery = ref.orderBy("timestamp");
        if (this.startMessages) {
          listenerQuery = listenerQuery.startAt(this.startMessages);
        }
        if (this.endMessages) {
          listenerQuery = listenerQuery.endAt(this.endMessages);
        }
        if (options.reset) this.messages = [];
        messages.forEach(message => {
          const formattedMessage = this.formatMessage(room, message);
          this.messages.unshift(formattedMessage);
        });
        const listener = listenerQuery.onSnapshot(snapshots => {
          // this.incrementDbCounter('Listen Room Messages', snapshots.size)
          this.listenMessages(snapshots, room);
        });
        this.listeners.push(listener);
      });
    },

    listenMessages(messages, room) {
      messages.forEach(message => {
        const formattedMessage = this.formatMessage(room, message);
        const messageIndex = this.messages.findIndex(
            m => m._id === message.id
        );

        if (messageIndex === -1) {
          this.messages = this.messages.concat([formattedMessage]);
        } else {
          this.messages[messageIndex] = formattedMessage;
          this.messages = [...this.messages];
        }

        this.markMessagesSeen(room, message);
      });
    },

    markMessagesSeen(room, message) {
      if (
          message.data().senderId !== this.currentUserId &&
          (!message.data().seen || !message.data().seen[this.currentUserId])
      ) {
        const roomsRef = firebase.firestore().collection("messagingRooms");
        const messagesRef = roomId =>
            roomsRef.doc(roomId).collection("messages");
        messagesRef(room.roomId)
            .doc(message.id)
            .update({
              [`seen.${this.currentUserId}`]: new Date()
            });
      }
    },

    formatMessage(room, message) {
      const senderUser = room.users.find(
          user => message.data().senderId === user._id
      );

      const {timestamp} = message.data();

      const formattedMessage = {
        ...message.data(),
        ...{
          _id: message.id,
          seconds: timestamp.seconds,
          timestamp: parseTimestamp(timestamp, this.facility.timeFormat),
          date: parseTimestamp(timestamp, "DD MMMM YYYY"),
          username: senderUser ? senderUser.username : null,
          avatar: senderUser ? senderUser.avatar : null,
          distributed: true
        }
      };

      if (message.data().replyMessage) {
        formattedMessage.replyMessage = {
          ...message.data().replyMessage,
          ...{
            senderId: message.data().replyMessage.senderId
          }
        };
      }

      return formattedMessage;
    },

    async sendMessage({content, roomId, files, replyMessage}) {

      const message = {
        senderId: this.user?.id,
        content,
        timestamp: new Date(),
        facilityId: this.currentFacility,
        username: this.user?.name
      };

      if (files) {
        message.files = this.formattedFiles(files);
      }

      if (replyMessage) {
        message.replyMessage = {
          id: replyMessage._id,
          content: replyMessage.content,
          senderId: replyMessage.senderId
        };

        if (replyMessage.files) {
          message.replyMessage.files = replyMessage.files;
        }
      }

      const roomsRef = firebase.firestore().collection("messagingRooms");
      const messagesRef = roomId => roomsRef.doc(roomId).collection("messages");
      const {id} = await messagesRef(roomId).add(message);

      if (files) {
        for (let index = 0; index < files.length; index++) {
          await this.uploadFile({
            file: files[index],
            messageId: id,
            roomId
          });
        }
      }
      roomsRef.doc(roomId).update({lastUpdated: new Date()});
    },

    async editMessage({messageId, newContent, roomId, files}) {
      const newMessage = {edited: new Date()};
      newMessage.content = newContent;

      if (files) {
        newMessage.files = this.formattedFiles(files);
      } else {
        const deleteDbField = firebase.firestore.FieldValue.delete();
        newMessage.files = deleteDbField;
      }

      const roomsRef = firebase.firestore().collection("messagingRooms");
      const messagesRef = roomId =>
          roomsRef.doc(roomId).collection("messages");
      await messagesRef(roomId)
          .doc(messageId)
          .update(newMessage);

      if (files) {
        for (let index = 0; index < files.length; index++) {
          if (files[index]?.blob) {
            await this.uploadFile({file: files[index], messageId, roomId});
          }
        }
      }
    },

    async deleteMessage({message, roomId}) {

      const roomsRef = firebase.firestore().collection("messagingRooms");
      const messagesRef = roomId => roomsRef.doc(roomId).collection("messages");
      await messagesRef(roomId).doc(message._id).update({deleted: new Date()});

      const {files} = message;

      const storageRef = firebase.storage().ref();
      const filesRef = storageRef.child("files");

      if (files) {
        files.forEach(file => {
          const deleteFileRef = filesRef
              .child(this.currentUserId)
              .child(message._id)
              .child(`${file.name}.${file.extension || file.type}`);

          deleteFileRef.delete();
        });
      }
    },

    async uploadFile({file, messageId, roomId}) {
      const storageRef = firebase.storage().ref();
      const filesRef = storageRef.child("files");
      let type = file.extension || file.type;
      if (type === "svg" || type === "pdf") {
        type = file.type;
      }

      const uploadFileRef = filesRef
          .child(this.currentUserId)
          .child(messageId)
          .child(`${file.name}.${type}`);

      if (type === "png" || type === "jpg" || type === "jpeg") {
        const image = await optimizePhotos(file.blob, '')
        const fileSizeInMegabytes = fileSizeToMB(image?.size);

        if (!validFileSize10MB(fileSizeInMegabytes)) {
          return;
        }

        await uploadFileRef.put(image, {contentType: type});
      } else {
        await uploadFileRef.put(file.blob, {contentType: type});
      }

      const url = await uploadFileRef.getDownloadURL();
      const roomsRef = firebase.firestore().collection("messagingRooms");
      const messagesRef = roomId =>
          roomsRef.doc(roomId).collection("messages");
      const messageDoc = await messagesRef(roomId)
          .doc(messageId)
          .get();

      const files = messageDoc.data().files;

      files.forEach(f => {
        if (f.url === file.localUrl) {
          f.url = url;
        }
      });

      await messagesRef(roomId)
          .doc(messageId)
          .update({files});
    },

    formattedFiles(files) {
      const formattedFiles = [];

      files.forEach(file => {
        const messageFile = {
          name: file.name,
          size: file.size,
          type: file.type,
          extension: file.extension || file.type,
          url: file.url || file.localUrl
        };

        if (file.audio) {
          messageFile.audio = true;
          messageFile.duration = file.duration;
        }

        formattedFiles.push(messageFile);
      });

      return formattedFiles;
    },

    async openFile({file}) {
     await fetch(file.file.url)
          .then(response => response.blob())
          .then(blob => {
            const updatedFile = new File([blob], file.file.name, {type: file.file.type});
            const url = window.URL.createObjectURL(updatedFile);
            const link = document.createElement('a');
            link.href = url;
            link.download = file.file.name;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
          })
    },

    async openUserTag({user}) {
      let roomId;

      this.rooms.forEach(room => {
        if (room.users.length === 2) {
          const userId1 = room.users[0].id;
          const userId2 = room.users[1].id;
          if (
              (userId1 === user.id || userId1 === this.currentUserId) &&
              (userId2 === user.id || userId2 === this.currentUserId)
          ) {
            roomId = room.roomId;
          }
        }
      });

      if (roomId) return (this.roomId = roomId);
      const roomsRef = firebase.firestore().collection("messagingRooms");
      const query1 = await roomsRef
          .where("facilityId", "==", this.currentFacility)
          .where("users", "==", [this.currentUserId, user.id])
          .get();

      if (!query1.empty) {
        return this.loadRoom(query1);
      }

      const query2 = await roomsRef
          .where("facilityId", "==", this.currentFacility)
          .where("users", "==", [user.id, this.currentUserId])
          .get();

      if (!query2.empty) {
        return this.loadRoom(query2);
      }

      const room = await roomsRef.add({
        users: [user.id, this.currentUserId],
        lastUpdated: new Date()
      });

      this.roomId = room.id;
      this.fetchRooms();
    },

    async loadRoom(query) {
      query.forEach(async room => {
        if (this.loadingRooms) return;
        const roomsRef = firebase.firestore().collection("messagingRooms");
        await roomsRef.doc(room.id).update({lastUpdated: new Date()});
        this.roomId = room.id;
        this.fetchRooms();
      });
    },

    menuActionHandler({action, roomId}) {
      switch (action.name) {
        case "inviteUser":
          return this.inviteUser(roomId);
        case "removeUser":
          return this.removeUser(roomId);
        case "deleteRoom":
          return this.deleteRoom(roomId);
      }
    },

    async sendMessageReaction({reaction, remove, messageId, roomId}) {
      const dbAction = remove
          ? firebase.firestore.FieldValue.arrayRemove(this.currentUserId)
          : firebase.firestore.FieldValue.arrayUnion(this.currentUserId);

      const roomsRef = firebase.firestore().collection("messagingRooms");
      const messagesRef = roomId =>
          roomsRef.doc(roomId).collection("messages");
      await messagesRef(roomId)
          .doc(messageId)
          .update({
            [`reactions.${reaction.unicode}`]: dbAction
          });
    },

    typingMessage({message, roomId}) {
      if (!roomId) return;

      if (message?.length > 1) {
        return (this.typingMessageCache = message);
      }

      if (message?.length === 1 && this.typingMessageCache) {
        return (this.typingMessageCache = message);
      }

      this.typingMessageCache = message;

      const dbAction = message
          ? firebase.firestore.FieldValue.arrayUnion(this.currentUserId)
          : firebase.firestore.FieldValue.arrayRemove(this.currentUserId);
      const roomsRef = firebase.firestore().collection("messagingRooms");
      roomsRef.doc(roomId).update({
        typingUsers: dbAction
      });
    },

    async listenRooms(query) {
      const listener = query.onSnapshot(rooms => {
        // this.incrementDbCounter('Listen Rooms Typing Users', rooms.size)
        rooms.forEach(room => {
          const foundRoom = this.rooms.find(r => r.roomId === room.id);
          if (foundRoom) {
            foundRoom.typingUsers = room.data().typingUsers;
            foundRoom.index = room.data().lastUpdated.seconds;
          }
        });
      });
      this.roomsListeners.push(listener);
    },

    updateUserOnlineStatus() {
      const userStatusRef = firebase
          .database()
          .ref("/status/" + this.currentUserId);

      const isOfflineData = {
        state: "offline",
        lastChanged: firebase.database.ServerValue.TIMESTAMP
      };

      const isOnlineData = {
        state: "online",
        lastChanged: firebase.database.ServerValue.TIMESTAMP
      };

      firebase
          .database()
          .ref(".info/connected")
          .on("value", snapshot => {
            if (snapshot.val() === false) return;

            userStatusRef
                .onDisconnect()
                .set(isOfflineData)
                .then(() => {
                  userStatusRef.set(isOnlineData);
                });
          });
    },

    listenUsersOnlineStatus(rooms) {
      rooms.map(room => {
        room.users.map(user => {
          const listener = firebase
              .database()
              .ref("/status/" + user.id)
              .on("value", snapshot => {
                if (!snapshot || !snapshot.val()) return;

                const lastChanged = this.formatTimestamp(
                    new Date(snapshot.val().lastChanged),
                    new Date(snapshot.val().lastChanged)
                );

                user.status = {...snapshot.val(), lastChanged};

                const roomIndex = this.rooms.findIndex(
                    r => room.roomId === r.roomId
                );

                this.rooms[roomIndex] = room;
                this.rooms = [...this.rooms];
              });
          this.roomsListeners.push(listener);
        });
      });
    },

    addRoom() {
      this.resetForms();
      this.addNewRoom = true;
    },

    async createRoom() {
      try {
        const roomsRef = firebase.firestore().collection("messagingRooms");
        this.disableForm = true;

        await roomsRef.add({
          facilityId: this.user.facilityId,
          users: [
            {
              _id: this.currentUserId,
              username: this.user.name,
              avatar: this.user.profilePicUrl
            }
          ],
          usersIds: [this.currentUserId],
          roomName: this.addRoomUsername,
          lastUpdated: new Date()
        });

        this.addNewRoom = false;
        this.addRoomUsername = "";
      } catch (e) {
        console.log("cant create room", e);
      }
      this.fetchRooms();
    },

    inviteUser(roomId) {
      this.resetForms();
      this.inviteRoomId = roomId;
    },

    async addRoomUser() {
      this.disableForm = true;

      const usersRef = firebase.firestore().collection("users");
      const {id} = await usersRef.add({username: this.invitedUsername});
      await usersRef.doc(id).update({id: id});
      const roomsRef = firebase.firestore().collection("messagingRooms");
      await roomsRef
          .doc(this.inviteRoomId)
          .update({users: firebase.firestore.FieldValue.arrayUnion(id)});

      this.inviteRoomId = null;
      this.invitedUsername = "";
      this.fetchRooms();
    },

    removeUser(roomId) {
      this.resetForms();
      this.removeRoomId = roomId;
      this.removeUsers = this.rooms.find(
          room => room.roomId === roomId
      ).users;
    },

    async deleteRoomUser() {
      this.disableForm = true;
      const roomRef = firebase.firestore().collection("messagingRooms");
      const roomDoc = (await firebase.firestore().collection("messagingRooms").doc(this.removeRoomId).get()).data()
      const users = roomDoc.users.filter(x => x._id !== this.removeUserId) || null
      const userIds = roomDoc.users.filter(x => x._id !== this.removeUserId).map(x => x._id) || null

      await roomRef.doc(this.removeRoomId).update({
        usersIds: userIds,
        users: users
      });

      this.removeRoomId = null;
      this.removeUserId = "";
      this.fetchRooms();
    },

    async deleteRoom(roomId) {
      const room = this.rooms.find(r => r.roomId === roomId);
      if (
          room.users.find(user => user.id === "SGmFnBZB4xxMv9V4CVlW") ||
          room.users.find(user => user.id === "6jMsIXUrBHBj7o2cRlau")
      ) {
        return alert("Nope, for demo purposes you cannot delete this room");
      }

      const roomsRef = firebase.firestore().collection("messagingRooms");
      const messagesRef = roomId =>
          roomsRef.doc(roomId).collection("messages");
      const ref = messagesRef(roomId);

      ref.get().then(res => {
        if (res.empty) return;
        res.docs.map(doc => ref.doc(doc.id).delete());
      });

      await roomsRef.doc(roomId).delete();

      this.fetchRooms();
    },

    resetForms() {
      this.disableForm = false;
      this.addNewRoom = null;
      this.addRoomUsername = "";
      this.inviteRoomId = null;
      this.invitedUsername = "";
      this.removeRoomId = null;
      this.removeUserId = "";
    },

    incrementDbCounter(type, size) {
      size = size || 1;
      this.dbRequestCount += size;
    }
  }
};
</script>

<style scoped>
.window-container {
  width: 100%;
}

.emoji-tooltip {
  padding: 5px;
  background-color: white;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.2);
}

.window-mobile form {
  padding: 0 10px 10px;
}

form {
  padding-bottom: 20px;
}

input {
  padding: 5px;
  width: 140px;
  height: 21px;
  border-radius: 4px;
  border: 1px solid #d2d6da;
  outline: none;
  font-size: 14px;
  vertical-align: middle;
}

input::placeholder {
  color: #9ca6af;
}

button {
  background: #1976d2;
  color: #fff;
  outline: none;
  cursor: pointer;
  border-radius: 4px;
  padding: 8px 12px;
  margin-left: 10px;
  border: none;
  font-size: 14px;
  transition: 0.3s;
  vertical-align: middle;
}

button:hover {
  opacity: 0.8;
}

button:active {
  opacity: 0.6;
}

button:disabled {
  cursor: initial;
  background: #c6c9cc;
  opacity: 0.6;
}

.button-cancel {
  color: #a8aeb3;
  background: none;
  margin-left: 5px;
}

select {
  vertical-align: middle;
  height: 33px;
  width: 152px;
  font-size: 13px;
  margin: 0 !important;
}
</style>
